module.exports = __webpack_public_path__ + "img/18c6535.jpg";